export default {
  // Navigation
  'nav.home': 'Startseite',
  'nav.play': 'Wie es funktioniert',
  'nav.store': 'Belohnungen',
  'nav.teamBuilding': 'Für Teams',
  'nav.events': 'Events',
  'nav.business': 'Für Unternehmen',
  'nav.about': 'Über uns',
  'nav.contact': 'Kontakt',
  'nav.startPlaying': 'Jetzt spielen',

  // Home Section
  'home.badge': 'Digitaler Stadtführer · Event-Marktplatz',
  'home.title1': 'Dein digitaler Stadtführer.',
  'home.slogan': 'Verwandle Städte in Spielplätze.',
  'home.heroDesc': 'CitySeek zeigt dir, was in deiner Stadt los ist, und macht das Erkunden zum Spiel. Finde Events, entdecke echte Orte zu Fuß und sammle nebenbei Belohnungen.',
  'home.startAdventure': 'Jetzt spielen',
  'home.watchVideo': 'Video ansehen',
  'home.feature1': 'Zu Fuß erkunden',
  'home.featureEvents': 'Events finden',
  'home.feature2': 'Orte verifizieren',
  'home.feature3': 'Münzen & Punkte',
  'home.feature4': 'Mit anderen chatten',
  'home.feature5': 'Im Ranking aufsteigen',
  'home.feature6': 'Bei Läden einlösen',
  'home.instantPlay': 'Läuft direkt im Browser. Kein App-Store, kein Download.',

  // Video Section
  'video.title': 'CitySeek in Aktion',
  'video.subtitle': 'Schau, wie Leute Darmstadt gerade erkunden.',
  'video.cta': 'Probier es in deiner Stadt',

  // Event Marketplace
  'marketplace.eyebrow': 'Neu · Event-Marktplatz',
  'marketplace.title': 'Der Event-Marktplatz deiner Stadt',
  'marketplace.subtitle': 'Sieh, was in deiner Nähe läuft, und lerne die Locations und Künstler dahinter kennen. Alles, was deine Stadt zu bieten hat, an einem Ort.',
  'marketplace.filterNearby': 'In der Nähe',
  'marketplace.filterTrending': 'Im Trend',
  'marketplace.filterWeek': 'Diese Woche',
  'marketplace.filterAll': 'Alle',
  'marketplace.events.title': 'Events',
  'marketplace.events.desc': 'Konzerte, Meetups, Märkte und Pop-ups in deiner Nähe.',
  'marketplace.venues.title': 'Locations',
  'marketplace.venues.desc': 'Cafés, Bars, Galerien und Bühnen. Lerne die Orte kennen, die deine Stadt ausmachen.',
  'marketplace.artists.title': 'Künstler',
  'marketplace.artists.desc': 'Folge lokalen Künstlern und Kreativen und verpasse keine Show mehr.',
  'marketplace.exploreCta': 'Schau, was läuft',
  'marketplace.partner.badge': 'Für Unternehmen',
  'marketplace.partner.title': 'Liste deine Location, Events & Künstler',
  'marketplace.partner.subtitle': 'Erreiche Locals, die ohnehin schon unterwegs sind. Veröffentliche Events, bau dir eine Community auf und bring mehr Leute zu dir.',
  'marketplace.partner.point1': 'Zeig deine Events Leuten, die gerade unterwegs sind',
  'marketplace.partner.point2': 'Bau dir eine Community für deine Location und Künstler auf',
  'marketplace.partner.point3': 'Sieh deine Reichweite, das Interesse und die Einlösungen',
  'marketplace.partner.listCta': 'Bei CitySeek listen',
  'marketplace.partner.talkCta': 'Sprich mit uns',

  // How It Works
  'howItWorks.title': 'So funktioniert\'s',
  'howItWorks.step1.title': 'Stadt & Spiel wählen',
  'howItWorks.step2.title': 'Laufen & Verifizieren',
  'howItWorks.step3.title': 'Geschichten entdecken',
  'howItWorks.step4.title': 'Erinnerungen teilen',
  'howItWorks.step5.title': 'Belohnungen verdienen',

  // Game Modes
  'games.title': 'Unsere Spielkategorien',
  'games.subtitle': 'Verschiedene Arten zu erkunden',
  'games.core.title': 'Kernspiel',
  'games.core.desc': 'Erkunde die Stadt in deinem Tempo, mit deinem eigenen Guide zu den besten Orten in Audio und Text.',
  'games.weekly.title': 'Timely Challenge',
  'games.weekly.desc': 'Soziale Events, die an einem lokalen Ort enden, mit Belohnungen zum Sammeln.',
  'games.custom.title': 'Individuelle Spiele',
  'games.custom.desc': 'Teamevents, Uni-Touren, Onboarding-Tage und private Gruppen.',

  // Store Section
  'store.title': 'CitySeek Store',
  'store.subtitle': 'Sammle Münzen beim Erkunden und löse sie in lokalen Cafés, Restaurants und Shops ein.',
  'store.step1': 'Münzen sammeln',
  'store.step1.desc': 'Aufgaben lösen und beim Erkunden verdienen',
  'store.step2': 'Belohnungen ansehen',
  'store.step2.desc': 'Sieh, was lokale Partner anbieten',
  'store.step3': 'Per QR einlösen',
  'store.step3.desc': 'Scannen und bei Partnern einlösen',
  'store.cta': 'Shop besuchen',

  // Team Building / Für Unternehmen
  'team.eyebrow': 'Für Unternehmen & Teams',
  'team.title': 'Stadtabenteuer für Teams & Marken',
  'team.subtitle': 'Individuelle Stadtspiele für Unternehmen, Universitäten und Veranstalter. Hol alle aus dem Besprechungsraum und gemeinsam raus in die Stadt.',
  'team.audience1': 'Unternehmen',
  'team.audience2': 'Universitäten',
  'team.audience3': 'Tour-Anbieter',
  'team.audience4': 'Marken & Events',
  'team.benefit1': 'Natürliche Zusammenarbeit',
  'team.benefit2': 'Aktives Engagement',
  'team.benefit3': 'Kreative Problemlösung',
  'team.benefit4': 'Lokale Entdeckungen',
  'team.benefit5': 'Bessere Kommunikation',
  'team.benefit6': 'Messbare Ergebnisse',
  'team.cta1': 'Individuelles Angebot',
  'team.cta2': 'Demo vereinbaren',

  // About Section
  'about.title': 'Über CitySeek',
  'about.subtitle': 'Eine neue Art, deine Stadt zu erleben.',
  'about.mission': 'Unsere Mission',
  'about.missionText': 'Wir wollen, dass sich das Erkunden deiner Stadt wieder aufregend anfühlt. Deshalb machen wir aus echten Orten Dinge zum Erleben und stärken dabei lokale Unternehmen und die Stadtkultur.',
  'about.vision': 'Unsere Vision',
  'about.visionText': 'Eine Welt, in der sich jede Stadt zum Entdecken lohnt.',
  'about.values': 'Unsere Werte',
  'about.value1': 'Authentische Entdeckung',
  'about.value2': 'Community First',
  'about.value3': 'Qualitätsinhalte',
  'about.value4': 'Spielerisches Lernen',
  'about.value5': 'Datenschutz & Sicherheit',
  'about.value6': 'Von Locals, für Locals',
  'about.value7': 'Lokale Unternehmen stärken',
  'about.team': 'Team',
  'about.teamSubtitle': 'Die Menschen hinter CitySeek',
  'about.team.safa': 'Leitet Produkt, Partnerschaften und die Richtung von CitySeek.',
  'about.team.umut': 'Baut die Technik, die CitySeek am Laufen hält.',
  'about.learnMore': 'Mehr erfahren',
  'about.getInTouch': 'Kontakt aufnehmen',

  // Contact
  'contact.title': 'Schreib uns',
  'contact.subtitle': 'Du möchtest deine Location oder dein Event eintragen, CitySeek in deine Stadt holen oder etwas mit deinem Team planen? Wir freuen uns auf deine Nachricht.',
  'contact.email': 'E-Mail',
  'contact.location': 'Standort',
  'contact.address': 'Hilpertstraße 31, 64295 Darmstadt-West, Deutschland',
  'contact.response': 'Antwortzeit',
  'contact.responseTime': 'Innerhalb von 24 Stunden',
  'contact.ctaTitle': 'Bereit zum Erkunden?',
  'contact.ctaSubtitle': 'Sei dabei und sieh deine Stadt mit ganz neuen Augen.',
  'contact.ctaButton': 'Jetzt spielen',
  'contact.form.getInTouch': 'Kontakt aufnehmen',
  'contact.form.subtitle': 'Partnerschaft, Sponsoring oder ein Teamspiel? Schreib uns einfach.',
  'contact.form.nameLabel': 'Name *',
  'contact.form.namePlaceholder': 'Dein Name',
  'contact.form.emailLabel': 'E-Mail *',
  'contact.form.emailPlaceholder': 'du@firma.de',
  'contact.form.companyLabel': 'Unternehmen',
  'contact.form.companyPlaceholder': 'Optional',
  'contact.form.cityLabel': 'Stadt',
  'contact.form.cityPlaceholder': 'Optional',
  'contact.form.useCaseLabel': 'Anliegen',
  'contact.form.useCaseDefault': 'Bitte wählen',
  'contact.form.useCase.listVenue': 'Location oder Event eintragen',
  'contact.form.useCase.artist': 'Künstler oder Band',
  'contact.form.useCase.partnership': 'Partnerschaft',
  'contact.form.useCase.customGame': 'Individuelles Spiel',
  'contact.form.useCase.teamAdventure': 'Team- oder Gruppenabenteuer',
  'contact.form.useCase.press': 'Presse',
  'contact.form.useCase.other': 'Sonstiges',
  'contact.form.messageLabel': 'Nachricht * (max. 500 Zeichen)',
  'contact.form.messagePlaceholder': 'Wie können wir helfen?',
  'contact.form.sendButton': 'Nachricht senden',
  'contact.form.sending': 'Wird gesendet …',
  'contact.form.successTitle': 'Danke, wir haben deine Nachricht erhalten.',
  'contact.form.successMessage': 'Wir melden uns bald bei dir.',

  // Footer
  'footer.tagline': 'Dein digitaler Stadtführer und Event-Marktplatz. Echte Abenteuer, echte Belohnungen.',
  'footer.product': 'Produkt',
  'footer.howItWorks': 'Wie es funktioniert',
  'footer.events': 'Event-Marktplatz',
  'footer.availableGames': 'Spielmodi',
  'footer.store': 'Belohnungs-Shop',
  'footer.teamBuilding': 'Für Teams',
  'footer.business': 'Für Unternehmen',
  'footer.company': 'Unternehmen',
  'footer.about': 'Über uns',
  'footer.contact': 'Kontakt',
  'footer.press': 'Presse',
  'footer.legal': 'Rechtliches',
  'footer.impressum': 'Impressum',
  'footer.privacy': 'Datenschutzerklärung',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.cookies': 'Cookie-Richtlinie',
  'footer.allRights': 'Alle Rechte vorbehalten.',
  'footer.social': 'Folge uns',

  // CityLab Pop-Up Widget
  'citylab.widget': 'CityLab Pop-Up',
  'citylab.title': 'CitySeek Pop-Up Darmstadt',
  'citylab.subtitle': 'Interaktive Galerie und kultureller Hotspot',
  'citylab.badge': 'März bis Mai 2026',
  'citylab.visit': 'Besuchen',
  'citylab.location': 'Luisenplatz 5, Darmstadt'
};
